import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { IconQuadCardStoryblok } from '../../../../types/storyblok';
import { Type } from '../../../../base/Type/Type';
import Markup from '../../../../base/Markup/Markup';
import Link from '../../../../base/Link/Link';
import { StoryblokImage } from '../../../../base/StoryblokImage/StoryblokImage';

export const IconQuadCard = ({
  heading,
  description,
  linkTitle,
  link,
  image,
}: IconQuadCardStoryblok) => {
  if (!heading && !description && !linkTitle && !link && !image) {
    return null;
  }

  return (
    <Box
      as="section"
      className="flew-row flex flex-nowrap gap-4 md:gap-8"
      overlayOverBkg
    >
      <Box as="div" className="flex-shrink-0">
        <StoryblokImage
          src={image}
          mode="responsive"
          maxWidth={300}
          alt={heading}
          className="h-20 w-20"
        />
      </Box>
      <Box as="div">
        <Type as="h3" className="mb-2 text-h4">
          {heading}
        </Type>
        <Markup content={description} className="mb-4 text-p1" />
        <Link href={link} variant="secondary">
          {linkTitle}
        </Link>
      </Box>
    </Box>
  );
};

export default IconQuadCard;
